import { Pipe, PipeTransform } from "@angular/core";

import { FormioBase } from "../../models/formio/formiobase";

@Pipe({ name: "applicableFormioComponents" })
export class ApplicableFormioComponentsPipe implements PipeTransform {
    public transform(all: FormioBase[]) {
        return all.filter((component) => {
            if (!component || !component.isAvailable) { return false; }
            if (!component.systemCodes.length) { return true; }
            return component.systemCodes.some((systemCode) => {
                return systemCode === "SV";
            });
        });
    }
}
